<script>
import RadiusMap from 'JIX/map/RadiusMap.js';
import debounce from 'lodash/debounce';

export default {
    props: {
        address: {
            type: String,
            default: "",
        },
        radius: {
            type: Number,
            default: null,
        },
        addressDebounce: {
            type: Number,
            default: 500,
        },
    },
    data() {
        return {
            map: null,
            debouncedCallback: debounce(this.updateMap.bind(this), this.addressDebounce),
        };
    },
    mounted() {
        this.map = new RadiusMap({ container: this.$el });
        this.updateMap();
    },
    beforeUnmount() {
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
    },
    watch: {
        address() {
            this.debouncedCallback();
        },
        radius() {
            this.updateMap();
        },
    },
    methods: {
        updateMap() {
            if (this.map) {
                if (this.address) {
                    this.map.updateAddress(this.address, this.radius);
                } else {
                    this.map.removeMarker();
                }
            }
        }
    },
};
</script>

<template>
    <div />
</template>
